/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Parameters for a test job
 */
export interface TestJobParams {
  entityIds: unknown[];
  operations: string[];
}
